<template>
  <v-footer dark class="white--text pr-2">
    <v-spacer />
    💖 Proudly brought to you by&nbsp;<a href="https://aiwebstudio.com" target="_blank">Active Improvement Web Studio</a>
  </v-footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
  a:hover {
    color: lightblue;
  }
</style>



// WEBPACK FOOTER //
// src/views/layouts/AppFooter.vue